import api from "service/api";

export function storeChats(data) {
  return api.post(`/store-chat`, data);
}

export function getChats(user1Id, user2Id) {
  return api.get(`/get-chat?user1Id=${user1Id}&user2Id=${user2Id}`);
}

export function deleteChatMessage(user1Id, user2Id, id) {
  return api.delete(
    `/delete-chat?user1Id=${user1Id}&user2Id=${user2Id}&chatId=${id}`,
  );
}

export function getAllEmployees(userId) {
  if (!userId) return Promise.resolve({ data: [] });
  return api.get(`/get-all-employees/${userId}`);
}

export function markAsRead(payload) {
  return api.post(`/mark-as-read`, payload);
}

export function searchMessages(params = {}) {
  const queryString = Object.entries(params)
    .filter(
      ([_, value]) => value !== "" && value !== null && value !== undefined,
    )
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(value)}`,
    )
    .join("&");

  return api.get(`/search?${queryString}`);
}
